'use strict';

function controller($attrs, $scope) {
    const vm = this;

    vm.auto_renew = false;
    vm.single_membership_link = '';
    vm.joint_membership_link = '';

    function updateLinks() {
        vm.single_membership_link = vm.auto_renew ? `${$attrs.singleMembershipLink}?recurring=true` : $attrs.singleMembershipLink;
        if ($attrs.jointMembershipLink) {
            vm.joint_membership_link = vm.auto_renew ? `${$attrs.jointMembershipLink}?recurring=true` : $attrs.jointMembershipLink;
        }
    }

    function init() {
        $scope.$watch(() => [vm.auto_renew], updateLinks, true);
        updateLinks();
    }

    init();

    return vm;
}

module.exports = [
    '$attrs',
    '$scope',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/MembershipPopup.js